var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { electron } from 'lib-shared-electron';
import { useCallback } from 'react';
import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { getLocalStorageDesktopAppNoticeCache } from '../../../localStorageDesktopAppNoticeCache/localStorageDesktopAppNoticeCache';
import { isDesktopAppCacheInvalidOrExpired } from './utils/isDesktopAppCacheInvalidOrExpired';
import { isDesktopAppVersionBelow } from './utils/isDesktopAppVersionBelow';
import { isDesktopAppVersionUnsupported } from './utils/isDesktopAppVersionUnsupported';
// Which versions of releases that should see this modal
const showForBelowVersion = '4.0.6';
// If the modal should also be shown for MSI standalone builds
const showForMsiStandalone = true;
// How many days until it should show again if cancelled
const daysToPostpone = 0;
// If the cache should be bypassed
const bypassAppNoticeCache = true;
/** A hook that checks if it should and shows a modal for desktop app users */
export const useDesktopAppNotice = () => {
    const dispatch = useAppDispatch();
    const trigger = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!electron.isElectron()) {
            return;
        }
        const isStandalone = yield electron.isStandaloneBuild();
        if (isStandalone && !showForMsiStandalone) {
            return;
        }
        const currentVersionIsBelow = yield isDesktopAppVersionBelow(showForBelowVersion);
        if (!currentVersionIsBelow) {
            return;
        }
        if (!bypassAppNoticeCache) {
            const desktopAppNoticeCache = getLocalStorageDesktopAppNoticeCache();
            const desktopAppCacheIsInvalidOrExpired = isDesktopAppCacheInvalidOrExpired(desktopAppNoticeCache);
            if (!desktopAppCacheIsInvalidOrExpired) {
                return;
            }
        }
        const isUnsupported = isDesktopAppVersionUnsupported();
        dispatch(appActions.showModal({
            modal: {
                type: 'app:desktopAppNotice',
                arg: {
                    daysToPostpone: isUnsupported ? 0 : daysToPostpone,
                    showForBelowVersion,
                },
            },
        }));
    }), [dispatch]);
    return trigger;
};
